import React from "react"
import { FooterProps } from "../interfaces"
import "./index.scss"
import { toPercentage } from "helpers/numbers"
import { useIntl } from "react-intl"

const Footer = (props: FooterProps) => {
	const intl = useIntl()

	return (
		<div className="footer-metrics">
			{props.details.map(({ detailName, detailValue }, idx) => (
				<div key={`metric-format-${idx}`}>
					<p>
						{detailValue != null && `${detailName}:`}
						<b>
							{detailValue != null &&
								toPercentage({
									value: detailValue,
									intl,
									decimals: 1,
									withPercentageChar: true,
								})}
						</b>
					</p>
				</div>
			))}
		</div>
	)
}

export default Footer
